"use client";
import Link from "next/link";
import Star from "lucide-react/dist/esm/icons/star";
import { useSession } from "@/contexts/SessionContext";
import { useSubscription } from "@/contexts/SubscriptionContext";
import { useFormatPrice } from "@/contexts/CurrencyContext";
import { useVatPricing } from "@/hooks/useViewerVat";

interface PlusPriceTagProps {
  price: number;
}

export function PlusPriceTag({ price }: PlusPriceTagProps) {
  const { user } = useSession();
  const { hasBuyerPlus } = useSubscription();
  const formatPrice = useFormatPrice();
  const vat = useVatPricing();

  // Only show for logged-in users who don't already get the Plus discount
  if (!user) return null;
  if (hasBuyerPlus) return null;
  if (price <= 0) return null;

  const plusPrice = price * 0.95;

  return (
    <Link
      href="/pricing"
      className="flex items-center gap-1.5 text-xs text-chart-2 hover:underline mt-1 group"
    >
      <Star className="h-3 w-3 fill-chart-2" />
      <span>
        With Plus: <span className="font-semibold">{formatPrice(vat.gross(plusPrice))}</span>
      </span>
    </Link>
  );
}
